import { render, staticRenderFns } from "./KullanimTaahhutnamesiKabul.vue?vue&type=template&id=66f5bf77&"
import script from "./KullanimTaahhutnamesiKabul.vue?vue&type=script&lang=js&"
export * from "./KullanimTaahhutnamesiKabul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports